import pptxgen from 'pptxgenjs'
import { percentageToInches, getCoordinates, joinTextValues } from '../helpers'
import { selectAll } from 'hast-util-select'
import { OPEN_SANS_REGULAR } from '../common/constants'
import renderSvgElement from '../render-svg'

function toDataURL(url, callback) {
  const xhr = new XMLHttpRequest()
  xhr.onload = function () {
    const reader = new FileReader()
    reader.onloadend = function () {
      callback(reader.result)
    }
    reader.readAsDataURL(xhr.response)
  }
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.send()
}

function getTranslateX(width) {
  switch (width) {
    case 1920:
      return percentageToInches(width / 4.2 / 1920, 'x')
    case 1000:
      return percentageToInches(width / 25 / 1920, 'x')
    case 960:
      return percentageToInches(width / -50 / 1920, 'x')
    case 940:
      return percentageToInches(width / -70 / 1920, 'x')
  }
}

function renderDonutChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)
  const pptx = new pptxgen()
  const groups = selectAll('g', svgNode)

  const translateX = getTranslateX(width)

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y, // + percentageToInches(((height / 100) * 12) / 1080, 'y'),
    h: percentageToInches(height / 1080, 'y'),
  }

  const legendGroup = [].concat.apply(
    [],
    groups
      .filter((group) => group.properties.class === 'st-donut-chart__legend')
      .map((legend) => legend.children)
  )

  // reverse the labels and values to match the order of original legend
  const labels = legendGroup
    .map((legend) => joinTextValues(legend.children[1].children[0]))
    .reverse()

  const values = legendGroup
    .map((legend) => joinTextValues(legend.children[legend.children.length - 1].children[0]))
    .map((percentageString) => parseFloat(percentageString) / 100)
    .reverse()

  // TODO: Add support for social media icons
  // const images = legendGroup
  //   .map((legend) => legend.children.find((child) => child.properties.class === 'svg-image'))
  //   .filter(Boolean)

  const colors = ['0679ff', '28d7c3', 'e592c6', 'f76d1e', 'ffd747']

  const dataChartPieStat = [
    {
      name: 'Education',
      labels,
      values,
    },
  ]

  const optsChartPie = {
    ...chartPosition,
    chartColors: colors,
    dataBorder: {
      pt: '0',
      color: 'F1F1F1',
    },
    dataLabelColor: 'FFFFFF',
    dataLabelFontSize: 8,
    legendFontFace: OPEN_SANS_REGULAR,

    layout: {
      x: 0,
      y: 0.15,
      w: 0.75,
      h: 0.7,
    },

    showLegend: true,
    showLabel: false,
    showValue: false,
    showPercent: true,

    holeSize: 40,

    title: 'Education',
    showTitle: false,
  }
  slide.addChart(pptx.charts.DOUGHNUT, dataChartPieStat, optsChartPie)
}

export default renderDonutChart
